export default __webpack_public_path__ + "static/media/cog-change-password.b0a529e5.svg";